'use strict';

var updateSortOptions = require('./search');
var util = require('app_custom_mufe/components/util');
var Utilites = require('app_custom_mufe/components/utilities');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('.filter-type-boolean input').each(function () {
        var booleanID = $(this).attr('id');
        $(this).closest('.refinement').find('label').attr('for', booleanID);
    })
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active');
    });
    updateDom($results, '.refinements');
    $('.refinements').attr('data-isfilterselected', $results.find('.refinements').attr('data-isfilterselected'));
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response, resetAll) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    if (resetAll) {
        [
            '.grid-header',
            '.header-bar',
            '.matadatatitle',
            '.matadatadescription',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.filter-box-revamp'
        ].forEach(function (selector) {
            updateDom($results, selector);
        });
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResultsNoRefinement(response, resetAll) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    if (resetAll) {
        [
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.filter-box-revamp'

        ].forEach(function (selector) {
            updateDom($results, selector);
        });
    }

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}


module.exports = function () {
    $('.filter-type-boolean input').each(function () {
        var booleanID = $(this).attr('id');
        $(this).closest('.refinement').find('label').attr('for', booleanID);
    });

    $(document).on('click', '.refinement-reset .reset-button-revamp', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var url = $(this).attr('data-url');

        $(this).closest('.secondary-bar').append('<a class="reset btn btn-underline" href="' + url + '"></a>');
        $(this).parents('.js-filter-modal-plp').find('.js-dialog-close-button').trigger('click');
        $(this).closest('.secondary-bar').find('.reset').trigger('click').remove();
        $(this).focus();
    });


    $(document).on('click', '.refinements .filter-type svg.refinement-click', function () {
        $(this).siblings('input').trigger('click');
    });

    $(document).on('keydown', '.js-ada-refinement', function (evt) {
        if (evt.key === ' ' || evt.key === 'Enter') {
            $(this).siblings('input').trigger('click');
        }
    });

    $(document).on('change', '.refinements .filter-type .refinement-button, .refinements input.refinement-click', function () {
        var url = $(this).attr('data-url');
        $(this).closest('.filter-type').append('<a class="refinement-link" href="' + url + '"></a>');
        $(this).closest('.filter-type').find('.refinement-link').trigger('click');
    });

    // Handle refinement value selection and reset click
    $(document).on('click', '.refinements .filter-type a, .refinement-reset, .filter-value a, .swatch-filter a', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('body').addClass('checked-input');

        $(this).trigger('search:filter', e);

        //fetching out currently selected filter
        var currentSelectedFilter = "filter " + $(this).parents('.card').find('.card-header').text().trim();
        var filterName = $(this).parents('.card').find('.card-header').text().trim();
        var refinementName = $(this).parents('.filter-type').find('.filter-text').text().trim();
        var displayId = $(this).parents('.filter-type').find('.filter-text').data('display-id');
        var refinementId = typeof displayId === 'string' && displayId.trim() || displayId || null;
        var $parentElm = $(this).parent();
        var $refinementcontent = $('#refinementContent').val();
        var resetAll = $(this).hasClass('reset');

        var oneFilterActivated1;

        if ($parentElm.find('i').hasClass('icon-BOX-SELECTED')) {
            if ($('.activeOneFilter').length > 1) {
                oneFilterActivated1 = false;
            } else {
                oneFilterActivated1 = true;
            }
        } else {
            if ($('.activeOneFilter').length > 0) {
                oneFilterActivated1 = false;
            } else {
                oneFilterActivated1 = true;
            }
        }

        var filterRemoved = true;
        var currentSelectedFilterValue;
        var currentTargetElm = $parentElm;

        if (currentTargetElm.find('.switch').length > 0) {
            currentSelectedFilterValue = currentSelectedFilter.replace('-', '').trim();
        } else if (currentTargetElm.find('.swatch-circle').length > 0) {
            var title = currentTargetElm.find('span').text();
            currentSelectedFilterValue = title;
        } else {
            currentSelectedFilterValue = 'Filter ' + currentTargetElm.find('span').text().trim();
        }

        function isJsonRefinementValue(valueState, refinementId) {
            var jsonBrutValue = (valueState !== undefined && valueState !== null) ? JSON.parse(valueState) : null;
            if (jsonBrutValue && jsonBrutValue[refinementId]) {
                return true;
            }
            return false;
        }

        $('.refinements .card-body .filter-type').each(function () {
            if ($(this).find('.switch').length > 0) {
                if ($(this).parents('.card').find('.card-header').text().trim() == filterName) {
                    if ($(this).find('.switch').find('input').prop("checked") == true) {
                        filterRemoved = false;
                    }
                }
            } else if ($(this).find('.swatch-circle').length > 0) {
                var title = $(this).find('span').text();
                if (title == currentSelectedFilterValue && $(this).find('.swatch-circle').hasClass('selected')) {
                    filterRemoved = false;
                }
            } else {
                if ($(this).find('i').length > 0) {
                    if ((currentTargetElm.find('span').text().trim() == $(this).find('span').text().trim()) && $(this).find('i').hasClass('icon-BOX-SELECTED')) {
                        filterRemoved = false;
                    }
                }
            }
        });

        //check if filter is being selected or removed
        if ($parentElm.find('i').hasClass('icon-BOX-SELECTED') || $parentElm.find('.swatch-circle').hasClass('selected') || $parentElm.find('input').prop('checked')) {
            currentSelectedFilter = "-" + currentSelectedFilter;
        }
        var isJsonRefinement = isJsonRefinementValue($refinementcontent, refinementId);

        $.ajax({
            url: e.currentTarget.href,
            data: {
                page: $('.js-grid-footer').data('page-number'),
                sectionName: filterName,
                filterName: refinementName,
                filterRemoved: filterRemoved,
                oneFilterActivated1: oneFilterActivated1,
                selectedUrl: e.currentTarget.href
            },
            method: 'GET',
            success: function (response) {
                var matadatadescriptionValue;
                if (oneFilterActivated1 && isJsonRefinement) {
                    window.history.pushState({
                        id: 'homepage'
                    }, 'Home | My App', e.currentTarget.href);
                    parseResults(response);
                    updateSortOptions.updateSortOptions(response);
                    matadatadescriptionValue = $('.matadatadescription').text().trim();
                    $('.title-meta').html($('.matadatatitle').html());
                    $("meta[name=description]").attr('content', matadatadescriptionValue);
                } else if ((!filterRemoved && !oneFilterActivated1 && $('.activeOneFilter').length >= 2) || resetAll) {
                    window.history.pushState({
                        id: 'homepage'
                    }, 'Home | My App', e.currentTarget.href);
                    parseResults(response, resetAll);
                    updateSortOptions.updateSortOptions(response);
                    matadatadescriptionValue = $('.matadatadescription').text().trim();
                    $('.title-meta').html($('.matadatatitle').html());
                    $("meta[name=description]").attr('content', matadatadescriptionValue);
                } else {
                    parseResultsNoRefinement(response, resetAll);
                    updateSortOptions.updateSortOptions(response);
                }

                // update apply button url with new filter parameters
                $('.apply-filters button').attr('data-url', e.currentTarget.href);

                // uncheck sorting option
                if (resetAll) {
                    $('.sorting-plp-option input[name=sort-order]:checked').prop('checked', false);
                    var resetUrl = $('.reset-button-revamp').attr('data-url');
                    $('.apply-filters button').attr('data-url', resetUrl);
                }
                $('body').trigger('LoadSliderImages');
                $('body').removeClass('checked-input');

                // datalayer for filters
                try {
                    var filterObj;
                    if (localStorage.getItem('selectedFilters')) {
                        filterObj = JSON.parse(localStorage.getItem('selectedFilters'));

                        if (filterRemoved) {

                            if ($.inArray(currentSelectedFilterValue, filterObj) > -1) {
                                filterObj = filterObj.filter(function (value) {
                                    return value != currentSelectedFilterValue;
                                })
                            }
                            localStorage.removeItem('selectedFilters');

                        } else {
                            if (currentSelectedFilter.indexOf("filter Product price") > -1) {
                                filterObj = filterObj.filter(function (value) {
                                    if (value.indexOf('Filter De') <= -1) {
                                        return value;
                                    }

                                })
                                filterObj.push(currentSelectedFilterValue);
                            } else {
                                filterObj.push(currentSelectedFilterValue);
                            }

                        }

                    } else {
                        if (!filterRemoved) {
                            filterObj = [];
                            filterObj.push(currentSelectedFilterValue);
                        }
                    }

                    if (filterObj !== undefined) {
                        localStorage.setItem('selectedFilters', JSON.stringify(filterObj));
                    }

                    //fetching out selected filter values
                    var selectedFilters = '';

                    if (localStorage.getItem('selectedFilters') && filterObj !== undefined) {
                        var finalFilterObj = JSON.parse(localStorage.getItem('selectedFilters'));

                        for (var i = 0; i < finalFilterObj.length; i++) {
                            selectedFilters += finalFilterObj[i] + ', ';
                        }
                    }

                    selectedFilters = selectedFilters.substring(0, selectedFilters.length - 2);

                    var resultCount = $('.result-count').find('.numberproduct-bold').text().trim();
                    dataLayer.push({
                        'filter': {
                            'refinement': currentSelectedFilter,
                            'refinement_values': selectedFilters,
                            'nb_result': parseInt(resultCount)
                        },
                        'event': "filter_selection"
                    });
                } catch (e) {
                    // TODO: handle exception
                    console.warn(e.message);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });


    $('.apply-filters button').on('click', function() {
        var url = $(this).attr('data-url');
        $.spinner().start();
        var isFilterSelected = $('.refinements').attr('data-isfilterselected') === 'true';
        var $sortingRuleElement = $('.sorting-plp-option input[name=sort-order]:checked');
        var data = {};
        if (isFilterSelected && $sortingRuleElement.length) {
            data = {
                'srule': $sortingRuleElement.attr('data-id')
            };
        }
        $.ajax({
            url: url,
            data: data,
            success: function(response) {
                var $results = $(response);
                // Update DOM elements that do not require special handling
                [
                    '.grid-header',
                    '.category-header',
                    '.header-bar',
                    '.header.page-title',
                    '.product-grid',
                    '.show-more',
                    '.filter-bar',
                    '.filter-box-revamp'
                ].forEach(function (selector) {
                    updateDom($results, selector);
                    if (util.isMobile() && $('.scroll1').length) {
                        $('.scroll1').insertAfter($('.scroll0'));
                    }
                });

                Utilites.adapteDescriptionFooterHandler();

                $('body').trigger('LoadSliderImages');
                $.spinner().stop();
            },
            error: function() {
                $.spinner().stop();
            }
        });
        $(this).parents('.js-filter-modal-plp').find('.js-dialog-close-button').trigger('click');
    });
}